export class Location {
    public OrganisationId: number;
    public LocationName: string;
    public LocationDescription: string;
}
